import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { CalendarGroup } from '../../models/calendar-group.model';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs/Observable';
import { publishReplay, refCount } from 'rxjs/operators';

@Injectable()
export class CalendarGroupService {

  calendarGroups: CalendarGroup[];
  calendarGroupEditing: CalendarGroup;

  private baseUrl = HttpClientService.BASE_MS_COMMON + '/calendar-group';
  private cachedFields: Observable<any>;

  constructor (
    private h: HttpClientService,
    private messageService: MessageService
  ) { }

  getAll(): Observable<CalendarGroup[]> {
    return this.h.get(this.baseUrl + '')
      .map(res => {
        return this.calendarGroups = res;
      });
  }

  get(id): Observable<CalendarGroup> {
    return this.h.get(this.baseUrl + '/' + id);
  }

  delete (record) {
    return this.h.delete(this.baseUrl + '/' + record.id)
      .map(res => {
        this.calendarGroups.splice(this.calendarGroups.indexOf(record), 1);
        this.messageService.add({severity: 'info', summary: 'Confirmed', detail: 'Calendar Group deleted'});
      });
  }

  post (newData: CalendarGroup) {
    return this.h.post(this.baseUrl + '/', newData)
      .map(res => {
        newData.id = res.id;
        this.calendarGroups.push(newData);
        this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });

  }

  put (data: CalendarGroup) {
    return this.h.put(this.baseUrl + '/', data)
      .map(res => {
        Object.assign(this.calendarGroupEditing, data);
        this.messageService.add({severity: 'info', summary: 'Success', detail: 'Operation success'});
      });
  }

  getFields() {
    if (!this.cachedFields) {
      this.cachedFields = this.h.get('/koncentro-common/schema/CalendarGroupDto').pipe(
        publishReplay(1), // this tells Rx to cache the latest emitted
        refCount() // and this tells Rx to keep the Observable alive as long as there are any Subscribers
      )
    }
    return this.cachedFields;
  }

}



// WEBPACK FOOTER //
// ./src/app/services/calendar-group/calendar-group.service.ts